import { Outlet } from "react-router";

import ProtocolCreateRoute from "./routes/ProtocolCreateRoute";
import ProtocolEditRoute from "./routes/ProtocolEditRoute";
import ProtocolListRoute from "./routes/ProtocolListRoute";

export const protocolRoutes = [
    {
        path: "protocols",
        handle: { breadcrumb: "protocol:protocolListScreen.title" },
        element: <Outlet />,
        children: [
            { index: true, element: <ProtocolListRoute /> },
            {
                path: "new",
                handle: { breadcrumb: "protocol:protocolCreateScreen.title" },
                element: <ProtocolCreateRoute />,
            },
            {
                path: ":protocolId",
                handle: { breadcrumb: "protocol:protocolEditScreen.title" },
                element: <ProtocolEditRoute />,
            },
        ],
    },
];
